import axios from 'axios'
import { format } from 'date-fns'
import { toast } from 'sonner'
import { Trans } from 'react-i18next'
import { DateFormat } from '../constants/index.jsx'
import { renderToString } from 'react-dom/server'

export const DataSourceCallbacks = {
  /**
   * Define load
   * @param options
   * @param url
   * @param config
   * @returns {Promise<{summary: *, data: *, groupCount: *, totalCount: *}>}
   */
  load: (options, url, config = {}) => {
    if (config.groupSummary && options.groupSummary && options.groupSummary.length > 0) {
      options.groupSummary = options.groupSummary.map((gs) => {
        if (config?.groupSummary?.[gs.selector]?.expression) {
          gs.expression = config.groupSummary[gs.selector].expression
        }

        return gs
      })
    }

    if (options.totalSummary && options.totalSummary.length > 0) {
      options.totalSummary = options.totalSummary.map((gs) => {
        if (config?.totalSummary?.[gs.selector]?.expression) {
          gs.expression = config.totalSummary[gs.selector].expression
        }

        return gs
      })
    }

    if (config.defaultSortLatest && !options.sort) {
      options.sort = [{ selector: 'id', desc: true }]
    }

    if (config.baseFilter) {
      const filter = config.baseFilter

      if (options.filter) {
        filter.push(options.filter)
      }

      options.filter = filter
    }

    return axios.get(url, {
      params: options
    }).then(res => {
      const result = res.data

      config.resultCallback && config.resultCallback(result)

      return {
        data: result.data,
        totalCount: result.totalCount,
        summary: result.summary,
        groupCount: result.groupCount
      }
    }).catch(err => {
      throw new Error(err.response.data.message)
    })
  },
  /**
   * Define insert
   * @param url
   * @param values
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  insert: (url, values) => {
    for (const [key, value] of Object.entries(values)) {
      if (value && value instanceof Date) {
        values[key] = format(value, DateFormat.serialization.dateTime)
      }
    }

    return axios.post(url, values).then(res => {
      toast.success(renderToString(<Trans i18nKey='messages.created_successfully' />))
      return res
    }).catch(err => {
      throw new Error(err.response.data.message)
    })
  },
  /**
   * Define update
   * @param url
   * @param values
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  update: (url, values) => {
    for (const [key, value] of Object.entries(values)) {
      if (value && value instanceof Date) {
        values[key] = format(value, DateFormat.serialization.dateTime)
      }
    }

    return axios.put(url, values).then(res => {
      toast.success(renderToString(<Trans i18nKey='messages.updated_successfully' />))
      return res
    }).catch(err => {
      throw new Error(err.response.data.message)
    })
  },
  /**
   * Define remove
   * @param url
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  remove: (url) => {
    return axios.delete(url).then(res => {
      toast.success(renderToString(<Trans i18nKey='messages.deleted_successfully' />))
      return res
    }).catch(err => {
      throw new Error(err.response.data.message)
    })
  },
  /**
   * Define byKey
   * @param url
   * @param config
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  byKey: (url, config = {}) => {
    return axios.get(url, config).then(res => {
      return res.data
    }).catch(err => {
      throw new Error(err.response.data.message)
    })
  }
}
